import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Get, Post, Query, Req } from '@nestjs/common';
import { ApiHeader, ApiQuery, ApiTags } from '@nestjs/swagger';
import { livetvlisttvResponseModel } from '../livetvlist/livetvlist-respone-module';
import { LivetvdetailsDTO, LivetvDTO, livetvStatusDTO } from './dto/livetv.dto';
import { AlllivetvResponseModel, livetvResponseModel, livetvstatusResponseModel } from './livetv-response-module';
import { LivetvService } from './livetv.service';
@ApiTags('livetv')
@Controller('livetv')
export class LivetvController {

    constructor (
        private LivetvService:LivetvService
    ) {}
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/create')
    @ApiQuery({name:'apiVersion'})
    async createlivetv(@Query() queryParams, @Body() LivetvdetailsDTO:LivetvdetailsDTO, @Req() request: Request): Promise<livetvlisttvResponseModel> {
        try {
            return await this.LivetvService.createlivetv(queryParams, LivetvdetailsDTO, request);
        } catch (error) {
            return errorHandler(livetvlisttvResponseModel, error);
        }
    }
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getlivetv')
    @ApiQuery({name:'apiVersion'})
    async getlivetv(@Query() queryParams, @Req() request:Request): Promise<AlllivetvResponseModel> {
        try {
            return await this.LivetvService.getlivetv(queryParams, request);
        } catch (error) {
            return errorHandler(AlllivetvResponseModel, error);
        }
    }
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/update')
    @ApiQuery({name:'apiVersion'})
    async updatelivetv(@Query() queryParams, @Body() LivetvdetailsDTO:LivetvdetailsDTO, @Req() request: Request): Promise<livetvlisttvResponseModel> {
        try {
            return await this.LivetvService.updatelivetv(queryParams, LivetvdetailsDTO, request);
        } catch (error) {
            return errorHandler(livetvlisttvResponseModel, error);
        }
    }
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('tv/update')
    @ApiQuery({name:'apiVersion'})
    async updatelivetvs(@Query() queryParams, @Body() LivetvDTO:LivetvDTO, @Req() request: Request): Promise<livetvlisttvResponseModel> {
        try {
            return await this.LivetvService.updatelivetvs(queryParams, LivetvDTO, request);
        } catch (error) {
            return errorHandler(livetvlisttvResponseModel, error);
        }
    }
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/updatelivetvStatus')
    @ApiQuery({name:'apiVersion'})
    async updatelivetvStatus(@Query() queryParams, @Body() livetvStatusDTO:livetvStatusDTO, @Req() request: Request): Promise<livetvstatusResponseModel> {
        try {
            return await this.LivetvService.updatelivetvStatus(queryParams, livetvStatusDTO, request);
        } catch (error) {
            return errorHandler(livetvstatusResponseModel, error);
        }
    }

}
